import { render, staticRenderFns } from "./Mouth12.vue?vue&type=template&id=a6dcd2be&"
import script from "./Mouth12.vue?vue&type=script&lang=js&"
export * from "./Mouth12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports